<template>

<div class="">

<!-- <FinancialData/> -->

<div class="row">
<div class="col-md-12">
<div class="panal mt-20">
<div class="panal-header">Current Scholarship</div> 
<div class="panal-body">


    <div class="table-responsive">
               <table class="table mt-3 table-bordered">
                <thead class="thead-light">
                  <tr>
                    <th scope="col">Scholarship Name</th>
                    <th scope="col">Offered Date</th>
                    <th scope="col">Scholarship Value</th>
                     <th scope="col">Active Status</th>
                     <th scope="col">Deserved Status </th>
                      <th scope="col">Semester </th>
                      

                  </tr>
                </thead>
                <tbody>
                  <tr v-if="CurrentScholarship.length > 0">
                   
                    <td>{{CurrentScholarship[0].RuleName}}</td>
                    <td>{{CurrentScholarship[0].OfferedDate}}</td>
                    <td >{{CurrentScholarship[0].ScholarshipValue}}%</td>
                    <td >{{CurrentScholarship[0].ActiveStatus}}</td>
                    <td >  {{CurrentScholarship[0].DeservedStatus}} </td>
                       <td >  {{CurrentScholarship[0].Semster}} </td>
                  </tr>
        <tr v-if="CurrentScholarship.length == 0">
                    <td colspan="6">No Data</td>
                  </tr>

                </tbody>
              </table>

              <div class="float-right m-3"> <b-button variant="success" v-on:click="isHidden = !isHidden">View Scholarship History</b-button></div>
</div>

</div>
</div>
</div>
</div>


<div class="row" v-if="isHidden">
<div class="col-md-12 mx-auto">
<div class="panal mt-20">
<div class="panal-header">Scholarship History</div> 
<div class="panal-body">


    <div class="table-responsive">
               <table class="table mt-3 table-bordered">
                <thead class="thead-light">
                  <tr>
                       <th scope="col">Scholarship Name</th>
                    <th scope="col">Offered Date</th>
                    <th scope="col">Scholarship Value</th>
                     <th scope="col">Active Status</th>
                     <th scope="col">Deserved Status </th>
                      <th scope="col">Semester </th>
                   

                  </tr>
                </thead>
                <tbody>
                  <tr v-if="empty"><td colspan="7"> No Data </td></tr>
                  <tr v-else v-for="item in HistoryScholarship" v-bind:Key="item.StudentID">
                   
                <td>{{item.RuleName}}</td>
                    <td>{{item.OfferedDate}}</td>
                    <td >{{item.ScholarshipValue}}%</td>
                    <td >{{item.ActiveStatus}}.</td>
                    <td >  {{item.DeservedStatus}} </td>
                       <td >  {{item.Semster}} </td>
                   
                  </tr>

             
                

                </tbody>
              </table>
</div>

</div>
</div>
</div>
</div>

</div>
</template>
<script>
// import FinancialData from "../../components/Financial/FinancialData.vue";
import studentData from '../../services/student/studentDataServices';
    export default {
      components: {
      // FinancialData,
  
  },
        name: 'Scholarship',
          data() {
      return {
        selected: null,
        show: true,
        isHidden: false,
        HistoryScholarship:'',
        CurrentScholarship:'',
        empty:true
      }
},
 computed:{
           currenUser(){
            return  this.$store.state.auth.user
          }
       },
mounted(){
        
      //this.currenUser.StudentID // 447
            studentData.GetStudentHistoryScholarship(this.currenUser.StudentID).then(Response =>{
              // this.isLoading = false ;
              this.empty = false
               this.HistoryScholarship = Response.data
                // eslint-disable-next-line no-console
                //  console.log(Response.data)
           }, error => {
              
                  // eslint-disable-next-line no-console
                 // console.log(error.response.status)
                 
              this.message =
                (error.response && error.response.data && error.response.data.Message) ||
                error.message ||
                error.toString();
                
                if(error.response.status == 404) this.message =''
             
            })


      //this.currenUser.StudentID // 447
            studentData.GetStudentCurrentScholarship(this.currenUser.StudentID).then(Response =>{
              // this.isLoading = false ;
               this.CurrentScholarship = Response.data
                // eslint-disable-next-line no-console
                //  console.log(Response.data)
           }, error => {
              
                  // eslint-disable-next-line no-console
                //  console.log(error.response.status)
                 
              this.message =
                (error.response && error.response.data && error.response.data.Message) ||
                error.message ||
                error.toString();
                
                if(error.response.status == 404) this.message =''
             
            })


      
    }

  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style >
h1{
    color: #285475;
    font-size: 25px;
    border-bottom: 1px #646464 dashed;
    padding: 10px 0px;
}
h1 a {
    color: #ff8600;
}

.panal{
  background:#fff;
  border-radius:10px;
color:#fff;
padding:0px 0px 20px 0px;
margin:10px 0;
   -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
    margin-bottom: 20px !important;

}
.panal-header{
    background: #285475;
    color: #FFFFFF;
    text-align: left;
    border-radius: 10px 0px 0px 0px;
    padding: 10px 20px;
    font-size: 17px;
    font-weight: bold;
        width: 50%;
  /*  -moz-box-shadow:    inset 0 0 5px #000000;
   -webkit-box-shadow: inset 0 0 5px #000000;
   box-shadow:  */
}
.panal-body{
    padding:20px;
    color:#333;
}

 .app-stu-photo {
    float: right;
    width: 200px;
    border-radius: 10px;
    border: 1px solid #111;
    margin-top: 20px;
  }

  .app-stu-photo img {
    width: 100%;
    border-radius: 10px;

  }

  .app-All {
    width: 75%;
    float: left;
  }

  .app-stu {
    border-bottom: 1px #333 dotted;
    padding: 10px 0px;
   
    float: left;

  }

  .app-stu .title {
    font-weight: bold;

  }

  .app-stu .title span {
    font-weight: 100;



  }

  .table .thead-dark th {
    color: #fff;
    background-color: #dee2e6 !important;
    border-color: #989899 !important;
    font-size: 13px !important;
  }
.table .thead-light th {
    color: #495057;
    background-color: #e9ecef;
    border-color: #dee2e6;
    font-size: 13px !important;
}

.bg-filter{
   background: #cacaca;
    padding: 10px;
    width:100%;
}
.show{
  display:none;
}

@media only screen and (max-width: 600px) {
  .panal-header{
       width: 90% !important;
  }
  .app-stu-photo {
  float: none;

 
 
}
}
</style>
